// category
export const SEO_RECOMMENDATION_TYPES = {
  CATEGORY: "category",
}